import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-channel-email",
  "use": "foquz-icon-channel-email-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" id=\"foquz-icon-channel-email\"><path d=\"M10 19a9 9 0 01-9-9 9 9 0 019-9 9 9 0 019 9v1.5a2.5 2.5 0 11-5 0V10m0 0a4 4 0 10-8 0 4 4 0 008 0z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol